"use client";

import { Button, Modal } from "antd";
import CloseIcon from "./close-icon.svg";
import styles from "./index.module.css";

type MobileWarningModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
};

export function MobileWarningModal({
  open,
  onClose,
  title = "OK",
  message = "For better creation experience, please switch to your computer.",
}: MobileWarningModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      title={null}
      footer={null}
      closeIcon={null}
      maskClosable={false}
      classNames={{
        content: styles.modalContent,
      }}
    >
      <CloseIcon
        className={styles.closeIcon}
        onClick={onClose}
        aria-label="Close"
      />

      <div className={styles.content}>
        <div className={styles.text}>{message}</div>

        <div className={styles.buttonContainer}>
          <Button type="primary" className={styles.okButton} onClick={onClose}>
            {title}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
